import { render, staticRenderFns } from "./orderSplitLog.vue?vue&type=template&id=00b07f71&scoped=true&"
import script from "./orderSplitLog.vue?vue&type=script&lang=js&"
export * from "./orderSplitLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b07f71",
  null
  
)

export default component.exports